exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".head-number {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: bold;\n  font-size: 176px;\n  color: #F5B821;\n}\n\n.back-number {\n  position: absolute;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: bold;\n  opacity: 8%;\n  font-size: 276px;\n  color: #F5B821;\n}\n\n.padding-bottom-150 {\n  padding-bottom: 150px;\n}\n\n.height-200 {\n  max-height: 200px;\n}", ""]);

// exports
